import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global varaible. In ES6, all imports are hoisted
// to the top of the file so if we used`import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
// import './lib/foundation-explicit-pieces';


$(document).foundation();

// Document stats.
// Update here to get written into the footer on every page.
var docNR = 'xxxx xxxxxx';
var nrDate = '2/2019';
var lastUpdate = 'June 28, 2019';
var copyYear = new Date().getFullYear();

$( document ).ready(function() {
    $("span#docNR").text(docNR);
    $("span#nrDate").text(nrDate);
    $("span#lastUpdate").text(lastUpdate);
    $("span#copyYear").text(copyYear);
    
    // Handle input focus to set fieldset color
    $("input").focus(function() {
        // console.log("Input focus");
        $(this).parent(".fieldset").addClass("focus");
        $(this).parent(".fieldset").find('label').addClass("label-focus");
    });
    $("input").blur(function() {
        // console.log("Input focus");
        $(this).parent(".fieldset").removeClass("focus");
        $(this).parent(".fieldset").find('label').removeClass("label-focus");
    });
});


function goBack() {
  window.history.back();
}

function modalOpen(modal) {
    var elm = '#' + modal;
    $(elm).foundation('open');
}